import { Routes, Route, Navigate } from 'react-router-dom';
import Layout, { WorkspacePage } from './components/Layout';
import Dashboards from './pages/Dashboards';
import DashboardView from './pages/DashboardView';
import Team from './pages/Team';
import Login from './pages/Login';
import Register from './pages/Register';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import Projects from './pages/Projects';
import Home from './pages/Home';
import { ProjectProvider } from './context/ProjectContext';
import { isLoggedIn } from './utils/currentUser';

function PrivateRoute({ children }) {
  return isLoggedIn() ? children : <Navigate to="/login" replace />;
}

// Signed-in users have nothing to do on the login/register screens.
function GuestRoute({ children }) {
  return isLoggedIn() ? <Navigate to="/projects" replace /> : children;
}

export default function App() {
  return (
    <ProjectProvider>
      <Routes>
        <Route path="/login" element={<GuestRoute><Login /></GuestRoute>} />
        <Route path="/register" element={<GuestRoute><Register /></GuestRoute>} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />

        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route element={<PrivateRoute><WorkspacePage /></PrivateRoute>}>
            <Route path="/projects" element={<Projects />} />
            <Route path="/app">
              <Route index element={<Navigate to="/app/dashboard" replace />} />
              <Route path="dashboard" element={<Dashboards />} />
              <Route path="dashboard/:id" element={<DashboardView />} />
              <Route path="team" element={<Team />} />
              {/* Old links (board, calendar, docs, …) land on the dashboards */}
              <Route path="*" element={<Navigate to="/app/dashboard" replace />} />
            </Route>
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
      </Routes>
    </ProjectProvider>
  );
}
